import React from 'react';
import {CloseIcon} from 'shared/icons';
import {Drawer} from 'shared/ui/Drawer';
import styles from './ReceiptInfoDrawer.module.css';

export interface ReceiptInfoDrawerProps {
	open: boolean;
	title: string;
	body: string;
	onClose: () => void;
}

export function ReceiptInfoDrawer({open, title, body, onClose}: ReceiptInfoDrawerProps): React.ReactElement {
	return (
		<Drawer
			open={open}
			onClose={onClose}
			panelClassName={styles.panel}
			bodyClassName={styles.body}
			footerClassName={styles.footer}
			footerContent={
				<button type="button" className={styles.ok} onClick={onClose}>
					Окей
				</button>
			}
		>
			<button type="button" className={styles.close} onClick={onClose} aria-label="Закрыть">
				<CloseIcon width={24} height={24} />
			</button>
			{title ? <h2 className={styles.title}>{title}</h2> : null}
			{body ? <p className={styles.text}>{body}</p> : null}
		</Drawer>
	);
}
